// @flow
import client from '../../client'
import buildGoogleLocation from './builders/googleLocation'

// Types
import type {
  PointOfInterestsResponse,
  SuggestionLocation,
} from '../../api_types'

export type Options = {
  lat?: number,
  lng?: number,
  lang?: string,
  provider?: string,
}

// API Endpoint
export const GEOCODE_ENDPOINT = '/locations/geocode/'

/**
 * Return points of interest from coordinates
 * @param {Object} data Coordinates information
 * @param {number} data.lat Coordinates latitude
 * @param {number} data.lng Coordinates longitude
 * @param {number} [data.lang] In which language the results should be returned
 * @param {number} [data.provider] 'google maps' or 'baidu maps'
 * @see {@link https://api-staging.mozio.com/v2/locations/docs/#!/geocode/Geocode_GET|Geocode}
 * @return {Promise|Error} A resolved Promise with points of interest or Rejected with an Error.
 */
export const getPointsOfInterest = (
  data: Options
): Promise<SuggestionLocation[]> =>
  client
    .get(GEOCODE_ENDPOINT, { query: data })
    .then((response: PointOfInterestsResponse) =>
      response.results.map(buildGoogleLocation)
    )

export default getPointsOfInterest
